/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetOrganizationPolicySettingsResponseDataFromJSON, GetOrganizationPolicySettingsResponseDataToJSON } from './GetOrganizationPolicySettingsResponseData';
export function GetOrganizationPolicySettingsResponseFromJSON(json) {
    return GetOrganizationPolicySettingsResponseFromJSONTyped(json, false);
}
export function GetOrganizationPolicySettingsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetOrganizationPolicySettingsResponseDataFromJSON(json['data'])
    };
}
export function GetOrganizationPolicySettingsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetOrganizationPolicySettingsResponseDataToJSON(value.data)
    };
}
